/**
 * *! This helper has unit tests.
 * If you make any changes to this file, you should run the unit tests:
 * npm test -- src/utest/webhooks/webhook_revision_helpers.test.ts
 */

import type { WebHooksRequest } from 'src/types/requests/settings/webhooks';

const WEBHOOK_LIST_MAX_ATTEMPTS = 3;
const WEBHOOK_LIST_RETRY_DELAY_MS = 400;

const sleep = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

export const getWebhookRevision = (response: WebHooksRequest): number | undefined =>
	response?.data?.rev ?? response?.rev;

export const isWebhookRevisionStale = (response: WebHooksRequest, expectedRev?: number): boolean =>
	expectedRev != null && (getWebhookRevision(response) ?? -1) < expectedRev;

export const shouldApplyWebhookList = (response: WebHooksRequest): boolean =>
	Boolean(response?.isok && !response?.data?.sleeping);

export const getWebHooksAtRevision = async (
	request: () => Promise<WebHooksRequest>,
	expectedRev?: number,
): Promise<WebHooksRequest> => {
	let response = await request();
	for (
		let attempt = 1;
		attempt < WEBHOOK_LIST_MAX_ATTEMPTS && isWebhookRevisionStale(response, expectedRev);
		attempt++
	) {
		await sleep(WEBHOOK_LIST_RETRY_DELAY_MS);
		response = await request();
	}
	return response;
};
